export const INN_LENGTH = [10, 12];
export const OGRN_LENGTH = [13, 15];
export const COMPANY_NAME_LENGTH = 200;
